// AppRoutes.ts
import React from 'react';
import { AppRoute } from './Models/AppRoute';
import EmptyLayout from '../Components/Layout/EmptyLayout';
import LandingLayout from '../Components/Layout/LandingLayout';
import Landing from '../Pages/Landing';
import DashboardPage from '../Pages/Dashboard';
import RequestAccountDeletion from '../Pages/RequestAccountDeletetion';
import MainContent from '../Components/Layout/MainContent';
import Login from '../Components/Content/Login';
import LoginLayout from '../Components/Layout/LoginLayout';

// NEW IMPORTS - Point to the new styled components

import AdminLayout from '../Components/Content/SideBar/SideBar';
import Dashboard from '../../src/Components/Content/Dashboard';
import PlayerListView from '../Components/Content/Players/PlayerListView/PlayerListView';
import PlayerDetailView from '../Components/Content/Players/PlayerDetailView/PlayerDetailView';
import AdministratorListView from '../../src/Components/Content/Administrators/AdministratorListView';
import AdministratorDetailView from '../Components/Content/Administrators/AdministratorDetailView/AdministratorDetailView';
import EditAdministratorPage from '../Pages/EditAdministrator/EditAdministratorPage';

// Phase 3-5 imports
import NotificationPage from '../Components/Content/Notifications/NotificationPage';
import AccountDeletionPage from '../Components/Content/AccountDeletion/AccountDeletionPage';
import BotQueuePage from '../Components/Content/BotQueue/BotQueuePage';
import RoleListPage from '../Components/Content/RoleManagement/RoleListPage';
import PromotionListPage from '../Components/Content/PromotionManagement/PromotionListPage';
import TutorialListPage from '../Components/Content/TutorialManagement/TutorialListPage';

import {
    AppstoreOutlined,
    TeamOutlined,
    NotificationOutlined,
    UserOutlined,
    DeleteOutlined,
    RobotOutlined,
    SafetyOutlined,
    ToolOutlined,
    GiftOutlined,
    PlayCircleOutlined,
} from "@ant-design/icons";
import Logout from '../Components/Content/Logout';
import PlayerManagementPage from '../Pages/Players/PlayerManagementPage';
import AdministratorManagementPage from '../Pages/Administrators/AdministratorManagementPage';
import AdminDetailFormPage from '../Pages/AddAdministrators';




const AppRoutes: AppRoute[] = [
    {
        path: '/',
        element: <Landing />,
        layout: LandingLayout,
        hideInMainMenu: true,
    },
    {
        path: '/RequestAccountDeletion',
        element: <RequestAccountDeletion />,
        hideInMainMenu: true,
        layout: LandingLayout,
    },
    {
        path: '/Login',
        element: <Login />,
        layout: LoginLayout,
        hideInMainMenu: true,
        title: 'Login',
    },
    {
        path: '/Admin',
        skip: true,
        redirect: 'Dashboard',
        icon: <AppstoreOutlined />,
        title: 'Admin',
        routes: [
            {
                path: 'Dashboard',
                element: <Dashboard />,  // ← Uses NEW styled dashboard
                layout: AdminLayout,
                requiredOperations: ['Access Dashboard'],
                hideInMainMenu: false,
                title: 'Dashboard',
                icon: <AppstoreOutlined />,
            },
            {
                path: 'Users',
                layout: AdminLayout,
                requiredOperations: ['Access Dashboard'],
                hideInMainMenu: false,
                title: 'Users',
                icon: <AppstoreOutlined />,
                routes: [
                    {
                        path: 'Players',
                        element: <PlayerListView />,  // ← Uses NEW styled player list
                        layout: AdminLayout,
                        requiredOperations: ['Access Dashboard'],
                        hideInMainMenu: false,
                        title: 'Players',
                        icon: <UserOutlined />,
                        routes: [
                            {
                                path: ':userId',
                                element: <PlayerDetailView />,
                                layout: AdminLayout,
                                requiredOperations: ['Access Dashboard'],
                                hideInMainMenu: true,
                                title: 'Player Details',
                            }
                        ]
                    },
                    {
                        path: 'Administrators',
                        element: <AdministratorListView />,  // ← Uses NEW styled admin list
                        layout: AdminLayout,
                        requiredOperations: ['Access Dashboard'],
                        hideInMainMenu: false,
                        title: 'Administrators',
                        icon: <UserOutlined />,
                        routes: [
                            {
                                path: 'Add',
                                element: <AdminDetailFormPage />,
                                layout: AdminLayout,
                                requiredOperations: ['Access Dashboard'],
                                hideInMainMenu: true,
                                skip: true,
                                title: 'Add Administrator',
                            },
                            {
                                path: ':userId',
                                element: <AdministratorDetailView />,
                                layout: AdminLayout,
                                requiredOperations: ['Access Dashboard'],
                                hideInMainMenu: true,
                                title: 'Administrator Details',
                                routes: [
                                    {
                                        path: 'Edit',
                                        element: <EditAdministratorPage />,
                                        layout: AdminLayout,
                                        requiredOperations: ['Access Dashboard'],
                                        hideInMainMenu: true,
                                        skip: true,
                                        title: 'Edit Administrator',
                                    }
                                ]
                            },
                        ]
                    },
                    {
                        path: 'Roles',
                        element: <RoleListPage />,
                        layout: AdminLayout,
                        requiredOperations: ['Access Dashboard'],
                        hideInMainMenu: false,
                        title: 'Roles',
                        icon: <SafetyOutlined />,
                    },
                ]
            },
          
            {
                path: 'Notifications',
                element: <NotificationPage />,
                layout: AdminLayout,
                requiredOperations: ['Access Dashboard'],
                hideInMainMenu: false,
                title: 'Notifications',
                icon: <NotificationOutlined />,
            },
            {
                path: 'Promotions',
                element: <PromotionListPage />,
                layout: AdminLayout,
                requiredOperations: ['Access Dashboard'],
                hideInMainMenu: false,
                title: 'Promotions',
                icon: <GiftOutlined />,
            },
            {
                path: 'Tutorials',
                element: <TutorialListPage />,
                layout: AdminLayout,
                requiredOperations: ['Access Dashboard'],
                hideInMainMenu: false,
                title: 'Tutorials',
                icon: <PlayCircleOutlined />,
            },
            {
                path: 'Operations',
                layout: AdminLayout,
                requiredOperations: ['Access Dashboard'],
                hideInMainMenu: false,
                title: 'Operations',
                icon: <ToolOutlined />,
                routes: [
                    {
                        path: 'AccountDeletions',
                        element: <AccountDeletionPage />,
                        layout: AdminLayout,
                        requiredOperations: ['Access Dashboard'],
                        hideInMainMenu: false,
                        title: 'Account Deletions',
                        icon: <DeleteOutlined />,
                    },
                    {
                        path: 'BotQueue',
                        element: <BotQueuePage />,
                        layout: AdminLayout,
                        requiredOperations: ['Access Dashboard'],
                        hideInMainMenu: false,
                        title: 'Bot Queue',
                        icon: <RobotOutlined />,
                    },
                ]
            },
        ]
    },
    {
        path: '/Logout',
        element: <Logout />,
        layout: LoginLayout,
        hideInMainMenu: true,
        title: 'Logout',
    },
];

export { AppRoutes };